import {
  HomeIcon,
  UsersIcon,
  CreditCardIcon,
  CalendarIcon,
  DocumentTextIcon,
  ChartBarIcon,
  UserPlusIcon,
  CogIcon,
  BuildingOfficeIcon,
  ArrowPathIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/partner-network",
    icon: HomeIcon,
    current: false,
    internalName: "dashboard",
    permissions: [],
  },
  {
    name: "Partners",
    href: "/partner-network/partners",
    icon: BuildingOfficeIcon,
    current: false,
    internalName: "partners",
    permissions: [],
  },
  {
    name: "Members",
    href: "/partner-network/members",
    icon: UsersIcon,
    current: false,
    internalName: "members",
    permissions: [],
  },
  {
    name: "Member Registrations",
    href: "/partner-network/registrations",
    icon: UserPlusIcon,
    current: false,
    internalName: "registrations",
    permissions: [],
  },
  {
    name: "Quarter Status",
    href: "/partner-network/quarter-status",
    icon: CalendarIcon,
    current: false,
    internalName: "quarter_status",
    permissions: [],
  },
  {
    name: "Transactions",
    href: "/partner-network/transactions",
    icon: CreditCardIcon,
    current: false,
    internalName: "transactions",
    permissions: [],
  },
  {
    name: "Member Rebates",
    href: "/partner-network/member-rebates",
    icon: CurrencyDollarIcon,
    current: false,
    internalName: "member_rebates",
    permissions: [],
  },
  {
    name: "Reports & Analytics",
    href: "/partner-network/reports",
    icon: ChartBarIcon,
    current: false,
    internalName: "reports",
    permissions: [],
  },
  {
    name: "Management",
    href: "#",
    icon: CogIcon,
    current: false,
    internalName: "management",
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN", "ROLE_PARTNER_ADMIN"],
    children: [
      {
        name: "Partner Administration",
        href: "/partner-network/admin/partners",
        icon: BuildingOfficeIcon,
        current: false,
        internalName: "admin_partners",
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN", "ROLE_PARTNER_ADMIN"],
      },
      {
        name: "System Analytics",
        href: "/partner-network/admin/analytics",
        icon: ChartBarIcon,
        current: false,
        internalName: "admin_analytics",
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN", "ROLE_PARTNER_ADMIN"],
      },
      {
        name: "Data Synchronization",
        href: "/partner-network/admin/sync",
        icon: ArrowPathIcon,
        current: false,
        internalName: "admin_sync",
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
      },
    ],
  },
];

const partnerNetworkConfig = {
  sectionName: "partnerNetwork",
  defaultRoute: "/partner-network",
  navigation,
};

export default partnerNetworkConfig;
